import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import FiberPinIcon from '@material-ui/icons/FiberPin';

import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputSelect from '~/components/Input/InputSelect';
import InputSelectAsync from '~/components/Input/InputSelectAsync';

import Form from '~/containers/Form';
import PinRecord from '~/records/PinRecord';
import { fetchUsers } from '~/utils/fetchUsers';
import Request from '~/providers/Request';

import useStyles from './styles';

const attrName = (attr) => PinRecord.hummanAttributeName(attr);

function PinForm({ record, setRecord, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  const [productsOptions, setProductsOptions] = useState([]);

  async function fetchProducts() {
    Request.get('/admin/products', null, { normalizeJSON: true })
      .then((response) => {
        setProductsOptions(response.data);
      })
      .catch((e) => {
        console.log(e);
        setProductsOptions([]);
      });
  }

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={FiberPinIcon}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={isPersisted ? t('pins.extras.edit') : t('pins.extras.create')}
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
                <InputControl
                  name={'product'}
                  value={record.get('product')}
                  label={attrName('product')}
                  required
                  inputComponent={InputSelect}
                  onChange={({ product }) => {
                    setRecord(record.updateAttributes({ product: product }));
                  }}
                  InputProps={{
                    isClearable: true,
                    labelKey: 'description',
                    options: productsOptions,
                    outValueType: 'object',
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
                <InputControl
                  name={'user'}
                  value={record.get('user')}
                  label={attrName('user')}
                  inputComponent={InputSelectAsync}
                  onChange={({ user }) => {
                    setRecord(record.updateAttributes({ user: user }));
                  }}
                  InputProps={{
                    isClearable: true,
                    handleFetch: fetchUsers,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

PinForm.propTypes = {
  record: PropTypes.instanceOf(PinRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

PinForm.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(PinForm));
